module.exports = __webpack_public_path__ + "images/admin/calc-fields.png";